import { render, staticRenderFns } from "./ViewerDashboardSidebar.vue?vue&type=template&id=3af94ec1&scoped=true&"
import script from "./ViewerDashboardSidebar.vue?vue&type=script&lang=js&"
export * from "./ViewerDashboardSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ViewerDashboardSidebar.vue?vue&type=style&index=0&id=3af94ec1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af94ec1",
  null
  
)

export default component.exports